import { SVGProps } from "react";

export const DrawingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 21"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    style={{ transition: "color 0.2s" }} // smooth color transition
  >
    <path
      d="M7.47917 9.37175L9.35417 7.49675L8.22917 6.35091L7.27083 7.28841L6.22917 6.24675L7.16667 5.28841L6 4.14258L4.125 6.01758L7.47917 9.37175ZM14 15.8926L15.875 14.0176L14.75 12.8717L13.7917 13.8092L12.75 12.7676L13.6875 11.8092L12.5208 10.6634L10.6458 12.5384L14 15.8926ZM6.1875 17.0176H3V13.8301L6.41667 10.4342L2 6.01758L6 2.01758L10.4167 6.43425L13.375 3.45508C13.5278 3.3023 13.6944 3.19119 13.875 3.12174C14.0556 3.0523 14.2431 3.01758 14.4375 3.01758C14.6319 3.01758 14.8194 3.0523 15 3.12174C15.1806 3.19119 15.3472 3.3023 15.5 3.45508L16.5625 4.51758C16.7153 4.67036 16.8264 4.83702 16.8958 5.01758C16.9653 5.19813 17 5.38563 17 5.58008C17 5.77452 16.9653 5.96202 16.8958 6.14258C16.8264 6.32313 16.7153 6.4898 16.5625 6.64258L13.5833 9.60091L18 14.0176L14 18.0176L9.58333 13.6009L6.1875 17.0176ZM4.5 15.5176H5.5625L13.375 7.70508L12.3125 6.64258L4.5 14.4551V15.5176ZM12.8542 7.16341L12.3125 6.64258L13.375 7.70508L12.8542 7.16341Z"
      fill="currentColor"
    />
  </svg>
);
